"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vernio": {
    "8c5cf503": [{
      "hkey": "99ab9e36",
      "slug": "mercatale-san-quirico",
      "name": "Mercatale-San Quirico",
      "primary": true,
      "skipSearch": false
    }],
    "mercatale": [{
      "hkey": "99ab9e36",
      "slug": "mercatale-san-quirico",
      "name": "Mercatale-San Quirico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6a9e4ab3": [{
      "hkey": "a639e9e3",
      "slug": "montepiano-la-storaia",
      "name": "Montepiano-La Storaia",
      "primary": true,
      "skipSearch": false
    }],
    "montepiano": [{
      "hkey": "a639e9e3",
      "slug": "montepiano-la-storaia",
      "name": "Montepiano-La Storaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5a01e103": [{
      "hkey": "99ab9e36",
      "slug": "mercatale-san-quirico",
      "name": "Mercatale-San Quirico",
      "primary": true,
      "skipSearch": false
    }],
    "san-quirico": [{
      "hkey": "99ab9e36",
      "slug": "mercatale-san-quirico",
      "name": "Mercatale-San Quirico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vernio"
    }]
  }
};
exports["default"] = _default;